import {createActionGroup, emptyProps} from '@ngrx/store';
import {ListData} from '@aviary/store/common/common.types';
import {CreateItemRequestValue, ITEM_REQUESTS_FEATURE_KEY, ItemRequest} from '@store/item-requests/item-requests.types';

export const ItemRequestsActions = createActionGroup({
  source: ITEM_REQUESTS_FEATURE_KEY,
  events: {
    'Load Item Request Details': (id: number) => ({id}),
    'Load Item Request Details Success': (itemRequest: ItemRequest) => ({itemRequest}),
    'Load Item Request Details Failure': (error: unknown) => ({error}),

    'Load Active Item Requests': emptyProps(),
    'Load Active Item Requests Success': (listData: ListData<ItemRequest>) => ({listData}),
    'Load Active Item Requests Failure': (error: unknown) => ({error}),

    'Load Closed Item Requests': emptyProps(),
    'Load Closed Item Requests Success': (listData: ListData<ItemRequest>) => ({listData}),
    'Load Closed Item Requests Failure': (error: unknown) => ({error}),

    'Show Create Item Request': emptyProps(),
    'Create Item Request': (value: CreateItemRequestValue) => ({value}),
    'Create Item Request Success': emptyProps(),
    'Create Item Request Failure': (error: unknown) => ({error}),

    'Mark Item Request Messages As Read': emptyProps(),
    'Mark Item Request Messages As Read Success': emptyProps(),
    'Mark Item Request Messages As Read Failure': (error: unknown) => ({error}),
    'Send Item Request Message': (itemRequestId: number, message: string) => ({itemRequestId, message}),
    'Send Item Request Message Success': emptyProps(),
    'Send Item Request Message Failure': (error: unknown) => ({error}),

    'Show Cancel Item Request': (itemRequest: ItemRequest) => ({itemRequest}),
    'Cancel Item Request': (itemRequest: ItemRequest) => ({itemRequest}),
    'Cancel Item Request Success': emptyProps(),
    'Cancel Item Request Failure': (error: unknown) => ({error}),
  }
});
